export default "__VITE_ASSET__C5Wgl3bE__"